/**
 * Bridge Session Booking API
 * @feature BRIDGE_SESSION_BOOKING - Create, list, reschedule bookings; admin schedule
 */

import { apiClient } from './apiClient';

export interface BridgeSessionBookingCreateRequest {
  scheduled_at: string;
  user?: {
    first_name: string;
    last_name: string;
    email: string;
    username: string;
    password: string;
    confirmPassword?: string;
  };
  company?: {
    company_name: string;
    industry: string;
    business_type: string;
    customer_count: number;
    years_in_business: number;
  };
  company_id?: string;
}

export interface BridgeSessionBookingCreateResponse {
  booking_id: string;
  user_id: string;
  company_id: string;
  artifact_tree_id: string;
  scheduled_at: string;
  status: string;
  access_token?: string;
  token_type: string;
  message: string;
}

export interface BridgeSessionBooking {
  id: string;
  scheduled_at: string;
  status: string;
  company_name?: string;
  company_id?: string;
  user_id?: string;
}

export const bridgeSessionBookingService = {
  async create(
    data: BridgeSessionBookingCreateRequest
  ): Promise<BridgeSessionBookingCreateResponse> {
    const response = await apiClient.post<BridgeSessionBookingCreateResponse>(
      '/bridge-session-bookings',
      data
    );
    return response.data;
  },

  async list(): Promise<BridgeSessionBooking[]> {
    const response = await apiClient.get<BridgeSessionBooking[]>(
      '/bridge-session-bookings'
    );
    return response.data;
  },

  async updateScheduledAt(
    bookingId: string,
    scheduled_at: string
  ): Promise<BridgeSessionBooking> {
    const response = await apiClient.patch<BridgeSessionBooking>(
      `/bridge-session-bookings/${bookingId}`,
      { scheduled_at }
    );
    return response.data;
  },

  async listAdminSchedule(): Promise<BridgeSessionBooking[]> {
    const response = await apiClient.get<BridgeSessionBooking[]>(
      '/bridge-session-bookings/admin/schedule'
    );
    return response.data;
  },

  /**
   * Mark booking as Completed. Grants BRIDGE_SESSION entitlement to company (ISSUE-181).
   * Admin or operator calls this when the session has been delivered.
   */
  async complete(bookingId: string): Promise<BridgeSessionBooking> {
    const response = await apiClient.patch<BridgeSessionBooking>(
      `/bridge-session-bookings/${bookingId}/complete`
    );
    return response.data;
  },
};
